import { FormTextField } from 'components/forms';
import { useContext } from 'react';
import { useForm } from 'react-hook-form';
import useSubmitNew from 'shared/hooks/useSubmitNew';
import MassActionModalLayout from 'shared/layouts/massActionModalLayout';
import { MassActionItemProps, UseMassActionProps } from 'shared/types';
import { MassActionForm } from 'types/backend';

type ReplaceTextActionForm = { newText: string };
export type ReplaceTextForm = MassActionForm<ReplaceTextActionForm>;

export type ReplaceTextProps<T> = MassActionItemProps<ReplaceTextForm, T, ReplaceTextActionForm> & {
    maxLength: number;
    isRequired?: boolean;
};

export default function ReplaceText<T>({
    defaultValues,
    maxLength,
    onSubmit,
    isLoading,
    tableDataContext,
    columnConfig,
    allRowsSelected,
    rowCount,
    isRequired = false,
}: ReplaceTextProps<T>) {
    const {
        handleSubmit,
        control,
        formState: { errors },
    } = useForm<ReplaceTextForm>({
        defaultValues,
    });

    return (
        <MassActionModalLayout
            isLoading={isLoading}
            tableDataContext={tableDataContext}
            columnConfig={columnConfig}
            allRowsSelected={allRowsSelected}
            rowCount={rowCount}
            submitHandler={handleSubmit(onSubmit)}
        >
            <FormTextField
                name={'actionForm.newText'}
                label='Comment'
                control={control}
                fieldError={errors?.['actionForm']?.['newText']}
                rules={{ maxLength, required: isRequired ? 'Comment is required' : undefined }}
            />
        </MassActionModalLayout>
    );
}

export function useReplaceTextMassAction<T>({
    controllerName,
    affectedDataContext,
    selected,
    allRowsSelected,
    onSuccess,
    endpoint = 'replaceText',
}: UseMassActionProps<T>) {
    const { filtersApplied } = useContext(affectedDataContext);

    const replaceTextMapper = (form: ReplaceTextForm) => ({
        ...form,
        filters: filtersApplied,
        selected,
        allRowsSelected,
    });

    return useSubmitNew({
        name: `${controllerName}/massaction/${endpoint}`,
        mapper: replaceTextMapper,
        context: affectedDataContext,
        onSuccess: onSuccess,
    });
}
